import React from "react";
import { connect } from "react-redux";
import { Form, Col, Row } from "react-bootstrap";

import { PhoneInput } from "react-international-phone";
import 'react-international-phone/style.css'

import GenerationsSelect from "../../../layout/select/generation";
import Address from "../../../layout/address";
import { deepEqual } from "../../../utils/object";

class Personal extends React.Component {
    constructor(props) {
        super(props);
        this.defaultCountry = "us";
        this.state = this.propsToState(props);
    }

    propsToState = (props) => ({
        firstName: props.firstName ?? "",
        middleName: props.middleName ?? "",
        lastName: props.lastName ?? "",
        generation: props.generation ?? "",
        phone: props.phone ?? "",
        fax: props.fax ?? "",
        Residence: props.Residence ?? {}
    });

    doCallChange = () => {
        if (this.props.onChange) this.props.onChange({ ...this.state });
    }

    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }, this.doCallChange);
    }

    onAddressChange = (objectName, values) => {
        this.setState({
            [objectName]: { ...values }
        }, this.doCallChange);
    }

    onGenerationChange = (value) => {
        const next = value?.value ?? value ?? "";
        this.setState({ generation: next }, this.doCallChange);
    };

    componentDidUpdate = (prevProps) => {
        const prevSlice = this.propsToState(prevProps);
        const nextSlice = this.propsToState(this.props);

        if (!deepEqual(prevSlice, nextSlice) && !deepEqual(this.state, nextSlice)) {
            this.setState(nextSlice);
        }
    }



    render() {
        return (
            <>
                <Row>
                    <Col lg="12">
                        <Row className="g-3">
                            <Col lg="12">
                                <h2 className="small-title">Personal Information</h2>
                            </Col>
                        </Row>
                        <Row className="g-3">
                            <Col lg="4">
                                <div className="mb-3 top-label">
                                    <Form.Control type="text" name="firstName" value={this.state.firstName || ""} onChange={this.onChange} />
                                    <Form.Label>FIRST NAME</Form.Label>
                                </div>
                            </Col>
                            <Col lg="2">
                                <div className="mb-3 top-label">
                                    <Form.Control type="text" name="middleName" value={this.state.middleName || ""} onChange={this.onChange} />
                                    <Form.Label>MIDDLE NAME</Form.Label>
                                </div>
                            </Col>
                            <Col lg="4">
                                <div className="mb-3 top-label">
                                    <Form.Control type="text" name="lastName" value={this.state.lastName || ""}  onChange={this.onChange} />
                                    <Form.Label>LAST NAME</Form.Label>
                                </div>
                            </Col>
                            <Col lg="2">
                                <div className="mb-3 top-label">
                                    <GenerationsSelect value={this.state.generation || ""} onChange={this.onGenerationChange} placeholder="" name="generation" />
                                    <Form.Label>SUFFIX</Form.Label>
                                </div>
                            </Col>
                        </Row>
                
                    </Col>
                </Row>

                <Row className="g-3">
                    <Col lg="12">
                        <h2 className="small-title">My Current Address</h2>
                    </Col>
                </Row>
                
                <Address
                    {...(this.state.Residence || {})}
                    onChange={(values) => this.onAddressChange("Residence", values)}
                />
                
                <Row className="g-3">
                    <Col md="6" lg="4" xxl="3"><h2 className="small-title">My Phone #</h2>
                        <div className="mb-3">
                            <PhoneInput name="phone" id="phone" defaultCountry={this.defaultCountry} value={this.state.phone || ""} onChange={(value) => this.onChange({
                                target: {
                                    name: "phone",
                                    value
                                }
                            })} />
                        </div>
                    </Col>
                    <Col md="6" lg="4" xxl="3"><h2 className="small-title">My Fax #</h2>
                        <div className="mb-3 top-label">
                            <PhoneInput name="fax" id="fax" defaultCountry={this.defaultCountry} value={this.state.fax || ""} onChange={(value) => this.onChange({
                                target: {
                                    name: "fax",
                                    value
                                }
                            })} />
                        </div>
                    </Col>
                </Row>
            </>
        );
    }
}

export default connect()(Personal);
